import React from 'react';
import { getName } from '@home/utils/common';
import { getLocale } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';

interface LegendConfigItem {
  nameEn: string;
  nameCn: string;
  color: string;
}

interface LabelConfig { legendConfig?: LegendConfigItem[];}

export const generateYAxisLabels = (trendConfig?: LabelConfig) => {
  if (!trendConfig) return null;
  const labels: Array<{ text: string; color: string; }> = [];
  const isEn = getLocale() === LANGUAGE_EN;
  
  if (trendConfig?.legendConfig && trendConfig?.legendConfig?.length > 0) {
    trendConfig?.legendConfig?.forEach((legend) => {
      labels.push({
        text: getName(isEn, legend.nameCn, legend.nameEn),
        color: legend.color,
      });
    });
  }

  if (labels.length === 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {labels.map((label, index) => (
        <div 
          key={`${label.text}-${index}`} 
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <span 
            style={{ 
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: label.color,
            }}
          />
          <span style={{ color: '#666', fontSize: '12px' }}>
            {label.text}
          </span>
        </div>
      ))}
    </div>
  );
};